export default {
	module: 'credits',
	actions: {
		list: true,
		create: true,
		dynamicPaths: [
			{
				paths: {
					'/credits/edit/:id': true,
				},
				keys: {
					':id': 3
				}
			}
		]
	}
}

